var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-input',{attrs:{"data-testid":"ad-group-name-index-iVF7np","disabled":_vm.disabled},model:{value:(_vm._name),callback:function ($$v) {_vm._name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"_name"}})}
var staticRenderFns = []

export { render, staticRenderFns }